import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../components/input/CustomLabelInput";
import { CustomLabelTextarea } from "../../../../../../../components/textarea/CustomLabelTextarea";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { useState } from "react";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { ReturnExchangeArchivesApi } from "../../../../../../../apis/ReturnExchangeArchivesApi";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { useFetcher } from "../../../../fetcher/useFetcher";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import _ from "lodash";
import { CustomColorPalette } from "../../../../../../../components/color-palette/CustomColorPalette";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }

    .textareaBox{
        border-color: #e0e0e0;
        border-radius: 3px;
    }

    .color-picker{
        .label{
            font-size: 14px;
            font-weight: 700;
            color: #333;
            margin-bottom: 5px;
        }

        .flexible{
            display: flex;
            gap: 10px;
            align-items: center;
            button{
                width: 35px;
                height:35px;
                border-radius: 3px;
            }

            .hex{
                font-size: 14px;
                font-weight: 700;
                color: #333;
            }
        }

    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    button{
        border-radius: 3px;
        border: none;
        color: #fff;
        background-color: #333;
        font-weight: 600;
    }
`;

export function EditModal({
    open,
    onClose,
    selectedArchive
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [formValue, setFormValue] = useState(_.cloneDeep(selectedArchive));

    const [backgroundColorPaletteOpen, setBackgroundColorPaletteOpen] = useState(false);
    const [fontColorPaletteOpen, setFontColorPaletteOpen] = useState(false);

    const handleChangeValue = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormValue({
            ...formValue,
            [name]: value
        });
    }

    const handleSubmit = async () => {
        if (!formValue.name) {
            customToast.error('보관함 이름은 필수 입력입니다.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [formValue]
        }

        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangeArchivesApi().updateList({ headers: headers, body: body });
        if (response?.content) {
            await fetcher.fetchReturnExchangeArchives();
            customToast.success('수정되었습니다.');
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            수정
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                    <StyledBody>
                        <div>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='text'
                                    name='name'
                                    value={formValue.name || ''}
                                    onChange={handleChangeValue}
                                />
                                <CustomLabelInput.Label>* 보관함 이름</CustomLabelInput.Label>
                            </CustomLabelInput>
                        </div>
                        <div>
                            <CustomLabelTextarea
                                boxClassName='textareaBox'
                                labelElement='보관함 설명'
                                name='description'
                                value={formValue.description || ''}
                                onChange={handleChangeValue}
                            >
                            </CustomLabelTextarea>
                        </div>
                        <div>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='number'
                                    name='sortOrder'
                                    value={formValue.sortOrder ?? ''}
                                    onChange={handleChangeValue}
                                />
                                <CustomLabelInput.Label>우선순위</CustomLabelInput.Label>
                            </CustomLabelInput>
                        </div>
                        <div className='color-picker'>
                            <div className='label'>배경색</div>
                            <div className='flexible'>
                                <CustomBlockButton
                                    type='button'
                                    style={{
                                        backgroundColor: formValue.backgroundColor
                                    }}
                                    onClick={() => setBackgroundColorPaletteOpen(true)}
                                ></CustomBlockButton>
                                <div className='hex'>{formValue?.backgroundColor || 'NaN'}</div>
                            </div>
                        </div>
                        <div className='color-picker'>
                            <div className='label'>글자색</div>
                            <div className='flexible'>
                                <CustomBlockButton
                                    type='button'
                                    style={{
                                        backgroundColor: formValue?.fontColor,
                                    }}
                                    onClick={() => setFontColorPaletteOpen(true)}
                                ></CustomBlockButton>
                                <div className='hex'>{formValue?.fontColor || 'NaN'}</div>
                            </div>
                        </div>
                    </StyledBody>
                    <StyledFooter>
                        <CustomBlockButton
                            type='submit'
                        >
                            적용
                        </CustomBlockButton>
                    </StyledFooter>
                </form>
            </CustomDialog>

            {backgroundColorPaletteOpen &&
                <CustomColorPalette
                    open={backgroundColorPaletteOpen}
                    fromColor={formValue.backgroundColor}
                    toggleOpenClose={setBackgroundColorPaletteOpen}
                    onConfirm={(color) => setFormValue(prev => { return { ...prev, backgroundColor: color } })}
                />
            }

            {fontColorPaletteOpen &&
                <CustomColorPalette
                    open={fontColorPaletteOpen}
                    fromColor={formValue.fontColor}
                    toggleOpenClose={setFontColorPaletteOpen}
                    onConfirm={(color) => setFormValue(prev => { return { ...prev, fontColor: color } })}
                />
            }
        </>
    );
}